import React, { useEffect, useState } from "react";
import api from "../../utils/apiAuth";
import { useDispatch, useSelector } from "react-redux";
import { IoIosCloseCircle } from "react-icons/io";
import Select from "react-select";
import { fetchPositions } from "../../redux/slices/positionSlice";
import {
  customSelectStyles,
  customSelectComponents,
} from "../../utils/inputStyles";

const PositionModal = ({ onChange }) => {
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [skills, setSkills] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(null);

  const { items: positions = [], loading } = useSelector(
    (state) => state.positions || {}
  );

  // Pozisyonları yükle
  useEffect(() => {
    dispatch(fetchPositions());
  }, [dispatch]);

  // Yetkinlikleri yükle
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await api.get("/skills");
        setOptions(response.data.data);
      } catch (error) {
        console.error("Yetkinlikler alınırken hata oluştu:", error);
      }
    };
    fetchSkills();
  }, []);

  // Parent'a değişiklikleri bildir
  useEffect(() => {
    if (!onChange || !selectedPosition) return;

    const rawPositionName = selectedPosition.value.replace(/^(Jr|Sr)\s/, "");
    const positionType = selectedPosition.value.startsWith("Jr")
      ? "JUNIOR"
      : selectedPosition.value.startsWith("Sr")
      ? "SENIOR"
      : "";

    const data = {
      positionName: rawPositionName,
      expectations: skills,
      positionType: positionType,
    };

    onChange(data);
  }, [selectedPosition?.value, skills.join(",")]);

  // API'den gelen options'ı react-select formatına dönüştürme
  const selectOptions = options.map((option) => ({
    label: option,
    value: option,
  }));

  // Seçilen değeri skills listesine ekleme
  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      const newValue = selectedOption.value;
      if (!skills.includes(newValue)) {
        setSkills([...skills, newValue]); // Yeni seçilen yetkinliği ekle
      }
      setSelectedValue(null); // Seçimi sıfırla
    }
  };

  const removeSkill = (yetkinlik) => {
    setSkills(skills.filter((item) => item !== yetkinlik)); // Yetkinliği listeden çıkar
  };

  // Pozisyonlar için react-select seçeneklerini oluştur
  //console.log("Positions from state:", positions); // Hata ayıklama için
  const positionOptions = (positions || [])
    .filter((pos) => pos && pos.name) // Geçersiz veya undefined elemanları filtrele
    .flatMap((pos) => [
      {
        label: `Jr ${pos.name}`,
        value: `Jr ${pos.name}`,
      },
      {
        label: `Sr ${pos.name}`,
        value: `Sr ${pos.name}`,
      },
    ]);

  return (
    <div className="flex gap-4 justify-start">
      <div className="flex flex-col gap-2 w-full">
        <label htmlFor="position" className="label-edit">
          Rol Seçiniz
        </label>
        <Select
          options={positionOptions}
          value={selectedPosition}
          onChange={(option) => setSelectedPosition(option)}
          placeholder="Rol seçiniz"
          styles={customSelectStyles}
          components={customSelectComponents}
          id="position"
          isSearchable={true}
          className="w-full"
        />
      </div>
      <div className="flex flex-col gap-2 w-full">
        <label htmlFor="skill" className="label-edit">
          Yetkinlik Ekleyiniz
        </label>
        <Select
          options={selectOptions}
          value={selectedValue}
          onChange={handleSelectChange}
          placeholder="Yetkinlik seçiniz"
          styles={customSelectStyles}
          components={customSelectComponents}
          id="skill"
          isSearchable={true}
          className="w-full"
        />
        <div className="flex flex-wrap gap-1 mb-8 mt-2">
          {skills.map((skill) => (
            <button
              key={skill}
              className="btn-green text-dark text-sm flex items-center gap-2 h-[36px]"
            >
              <span>{skill}</span>
              <span onClick={() => removeSkill(skill)}>
                <IoIosCloseCircle />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(PositionModal);
